import { Routes, Route } from "react-router-dom";
import GalleryButtons from "../components/gallery-buttons";
import Afrostalgia from "../components/afrostalgia";
import Afrostalgia2 from "../components/afrostalgia2";
import AfroSounds from "../components/afrosounds";
import TacExperience from "../components/tac-experience";
import IntroSummer from "../components/introsummer";
import { Link } from "react-router-dom";
import Offseason from "../components/offseason";
import { ArrowLeft } from "../constants/icons";

const GalleryPage = () => {
  return (
    <>
      <div className="gallery-page" id="hero">
        <div className="buttons-back">
          <Link to="/gallery" className="gallery-arrow-left">
            <ArrowLeft className="ico" />
          </Link>
          <GalleryButtons />
        </div>
        <Routes>
          <Route path="afrostalgia" element={<Afrostalgia />} />
          <Route path="afrostalgia2" element={<Afrostalgia2 />} />
          <Route path="afrosounds" element={<AfroSounds />} />
          <Route path="tacexperience" element={<TacExperience />} />
          <Route path="introsummer" element={<IntroSummer />} />
          <Route path="theoffseason" element={<Offseason />} />
        </Routes>
      </div>
    </>
  );
};

export default GalleryPage;
